import {useCompanyAnnualStore} from '@/store/audit/companyAnnualStore';
import {useFsAdjustStore} from "@/store/audit/fsAdjustStore";
import type {FsSimpleData} from '@/services/auditService/auditAdjustmentService';

export type AuditMeta = {
    periodFrom: string | null;
    periodTo: string | null;
    yearOfAssessment: string | null;
    lastYearOfAssessment: string | null;
    currency: string;
    line: FsSimpleData | null;
    paperDetail: any[] | null;
};

/**
 * Fetch Year of Assessment, Last Year of Assessment and Presentation Currency
 * for a given annualId using company annual store and adjustment store.
 * Uses fsAdjustStore instead of fsCategoryStore for adjustment-specific data.
 */
export async function fetchAdjustMeta(annualId: number, code?: string, companyId?: number, skipWpDetail?: boolean): Promise<AuditMeta> {
    try {
        const state = useCompanyAnnualStore.getState();
        const adjustState = useFsAdjustStore.getState();
        const [yoaRes, currencyRes] = await Promise.all([
            state.getYearOfAssessment(annualId),
            state.getPresentationCurrency(annualId),
        ]);

        let adjustLine: FsSimpleData | null = null;
        let paperDetail: any[] | null = null;
        const sc = code?.trim();
        if (sc) {
            adjustLine = adjustState.getLineByCode(sc);
            
            // 调用 getPaperDetail 获取工作底稿详情
            // skipWpDetail=true 时跳过，避免与 useAdjustDialogData Step2 重复请求
            if (!skipWpDetail && companyId && annualId) {
                try {
                    paperDetail = await adjustState.getWpDetail(companyId, annualId, sc);
                } catch (error) {
                    paperDetail = null;
                }
            }
        }

        return {
            periodFrom: yoaRes.periodFrom ?? null,
            periodTo: yoaRes?.periodTo ?? null,
            yearOfAssessment: yoaRes?.yearOfAssessment ?? null,
            lastYearOfAssessment: yoaRes?.lastYearOfAssessment ?? null,
            currency: String(currencyRes || ''),
            line: adjustLine,
            paperDetail: paperDetail,
        };
    } catch {
        return {
            periodFrom: null,
            periodTo: null,
            yearOfAssessment: null,
            lastYearOfAssessment: null,
            currency: '',
            line: null,
            paperDetail: null
        };
    }
}
